export const styles = (theme) => ({
  // Filter Button
  filterButton: {
    backgroundColor: "transparent",
    borderRadius: theme.spacing(1),
    // padding: theme.spacing(1),
    "&:hover": {
      backgroundColor: theme.palette.grey[100],
    },
  },

  // Popover Container
  popover: {
    width: "180px",
    maxHeight: "300px",
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[4],
    border: `1px solid ${theme.palette.divider}`,
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },

  // Header Section
  header: {
    padding: `${theme.spacing(1)} ${theme.spacing(1.5)} ${theme.spacing(0.75)} ${theme.spacing(1.5)}`,
    backgroundColor: theme.palette.grey[50],
    borderBottom: `1px solid ${theme.palette.divider}`,
  },

  // Search Input
  searchInput: {
    "& .MuiOutlinedInput-root": {
      height: "32px",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(0.75),
      fontSize: "12px",
      "& fieldset": {
        borderColor: theme.palette.grey[300],
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
        borderWidth: "1px",
      },
    },
  },

  searchIcon: {
    fontSize: 16,
    color: theme.palette.grey[500],
  },

  // Content Section
  content: {
    maxHeight: "160px",
    overflowY: "auto",
    backgroundColor: theme.palette.background.paper,
    "&::-webkit-scrollbar": {
      width: "4px",
    },
    "&::-webkit-scrollbar-track": {
      background: theme.palette.grey[100],
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.grey[300],
      borderRadius: "2px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: theme.palette.grey[400],
    },
  },

  // Loading State
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(2.5),
  },

  loadingSpinner: {
    color: theme.palette.primary.main,
  },

  // Empty State
  emptyState: {
    textAlign: "center",
    padding: theme.spacing(2.5),
  },

  emptyStateText: {
    color: theme.palette.grey[500],
    fontSize: "12px",
  },

  // Select All Option
  selectAllContainer: {
    display: "flex",
    alignItems: "center",
    padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
    cursor: "pointer",
    backgroundColor: theme.palette.primary.grey + "10",
    borderBottom: `1px solid ${theme.palette.primary.grey + "40"}`,
    fontWeight: 500,
    transition: "background-color 0.15s ease",
    "&:hover": {
      backgroundColor: theme.palette.primary.grey + "20",
    },
  },

  selectAllCheckbox: {
    marginRight: theme.spacing(1),
    // color: theme.palette.grey[600],
    padding: theme.spacing(0.25),
    "&.Mui-checked": {
      //   color: theme.palette.primary.main
    },
    "&.MuiCheckbox-indeterminate": {
      //   color: theme.palette.primary.main
    },
  },

  selectAllText: {
    fontSize: "12px",
    fontWeight: 500,
    // color: theme.palette.text.primary
  },

  // Filter Options
  optionContainer: {
    display: "flex",
    alignItems: "center",
    padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
    cursor: "pointer",
    transition: "background-color 0.15s ease",
    "&:hover": {
      backgroundColor: theme.palette.grey[50],
    },
  },

  optionCheckbox: {
    marginRight: theme.spacing(1),
    color: theme.palette.grey[600],
    padding: theme.spacing(0.25),
    "&.Mui-checked": {
      color: theme.palette.primary.main,
    },
  },

  optionText: {
    fontSize: "12px",
    color: theme.palette.text.secondary,
    fontWeight: 400,
  },

  // No Results State
  noResultsContainer: {
    textAlign: "center",
    padding: theme.spacing(2),
  },

  noResultsText: {
    color: theme.palette.grey[500],
    fontSize: "12px",
  },

  // Footer Section
  footer: {
    padding: `${theme.spacing(0.75)} ${theme.spacing(1.5)} ${theme.spacing(1)} ${theme.spacing(1.5)}`,
    backgroundColor: theme.palette.grey[50],
    borderTop: `1px solid ${theme.palette.divider}`,
  },

  buttonContainer: {
    display: "flex",
    gap: theme.spacing(0.75),
  },

  // Action Buttons
  resetButton: {
    flex: 1,
    fontSize: "11px",
    fontWeight: 500,
    textTransform: "none",
    borderRadius: theme.spacing(0.5),
    minWidth: "auto",
    px: theme.spacing(1.5),
  },

  applyButton: {
    flex: 1,
    fontSize: "11px",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.primary.main,
    minWidth: "auto",
    px: theme.spacing(1.5),
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
});
